
import storage from 'redux-persist/lib/storage'; // Usa localStorage
import persistFilter from './transformPersist';

// Agrego oscar.
/*const pcdhPersist = {
    key: 'pcdhPersist',
    storage, // Puedes cambiar esto a 'sessionStorage' o 'indexedDB' si lo prefieres
};*/

const tokenPersist = {
    key: 'tokenPersist',
    storage,
    transforms: [persistFilter],
}



export {  tokenPersist }

